import { frontendURL } from '../../../helper/URLHelper';
import FunnelsView from 'dashboard/components-next/funnels/pages/FunnelsView.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/funnels'),
    name: 'funnels_index',
    component: FunnelsView,
    meta,
  },
];
